class HpLegalLayout extends HTMLElement {
  connectedCallback() {
    this.onResize = this.onResize.bind(this);
    window.addEventListener("resize", this.onResize);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.scrollActiveMobileLink();
        this.scrollActiveSidebarLink();
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize() {
    this.scrollActiveMobileLink();
    this.scrollActiveSidebarLink();
  }

  scrollActiveMobileLink() {
    if (window.innerWidth >= 1000) {
      return;
    }

    const activeLink = this.querySelector(".hp-legal-layout__mobile-scroll .is-active");
    if (!activeLink) {
      return;
    }

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    activeLink.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      block: "nearest",
      inline: "center",
    });
  }

  scrollActiveSidebarLink() {
    if (window.innerWidth < 1000) {
      return;
    }

    const sidebarNav = this.querySelector(".hp-legal-layout__sidebar-nav");
    const activeLink = sidebarNav?.querySelector(".is-active");

    if (!sidebarNav || !activeLink) {
      return;
    }

    activeLink.scrollIntoView({
      behavior: "auto",
      block: "nearest",
    });
  }
}

if (!window.customElements.get("hp-legal-layout")) {
  window.customElements.define("hp-legal-layout", HpLegalLayout);
}
